import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SortOption } from '@/utils/query-filters';
import {
    getSortFromSearchParams,
    setSortInSearchParams,
} from '@/utils/query-url-params';

export function useSortFromUrl(
    defaultSort: SortOption,
): [SortOption, (option: SortOption) => void] {
    const [searchParams, setSearchParams] = useSearchParams();

    const sortOption = useMemo(
        () => getSortFromSearchParams(searchParams, defaultSort),
        [searchParams, defaultSort],
    );

    const setSortOption = useCallback(
        (option: SortOption) => {
            setSearchParams(
                setSortInSearchParams(searchParams, option, defaultSort),
                { replace: true },
            );
        },
        [searchParams, setSearchParams, defaultSort],
    );

    return [sortOption, setSortOption];
}
